import { getSiteModule } from 'env_def';
import { PopupWinPriority } from '@web-common/popup_state/state';
import { WAIMAO_PRODUCT_VERSIONS } from '@web-common/conf/waimao/constant';
function checkModuleMatched(item, moduleId) {
    if (!item.forModuleId) {
        return true;
    }
    else if (typeof item.forModuleId === 'string') {
        return item.forModuleId == '' || item.forModuleId === moduleId;
    }
    else if (Array.isArray(item.forModuleId)) {
        return item.forModuleId.includes(moduleId);
    }
}
function getSelectedWin(allWins, now, moduleId, showUserGuide, idPrefix) {
    const popUpWinItems = Object.values(allWins);
    let selectedWin = null;
    for (let idx = 0; idx < popUpWinItems.length; idx++) {
        const item = popUpWinItems[idx];
        if (!showUserGuide && item.forNew) {
            continue;
        }
        const typePriority = PopupWinPriority[item.type];
        const hasRegisteredTime = item.registerTime && item.registerTime > 0;
        const hasLastShowTime = item.lastShowTime && item.lastShowTime > 0;
        const setNotShow = item.setNoShow && (!item.notShowPeriod || (hasLastShowTime && now - item.lastShowTime < item.notShowPeriod * 24 * 3600000));
        const showed = !item.showOnceMoreEachDay && hasLastShowTime && now - item.lastShowTime < 24 * 3600000;
        const moduleMatched = checkModuleMatched(item, moduleId);
        console.log('[popup] check', item, hasRegisteredTime, hasLastShowTime, setNotShow, showed, moduleMatched);
        if (hasRegisteredTime && !item.canceled && !setNotShow && !showed && moduleMatched) {
            if (selectedWin) {
                const selectedTypePriority = PopupWinPriority[selectedWin.type];
                if (typePriority > selectedTypePriority) {
                    selectedWin = item;
                }
                else if (typePriority === selectedTypePriority) {
                    if (item.priority > selectedWin.priority) {
                        selectedWin = item;
                    }
                }
            }
            else {
                selectedWin = item;
            }
        }
    }
    if (selectedWin && idPrefix && idPrefix.length > 0 && selectedWin.id.indexOf(idPrefix) !== 0) {
        selectedWin = null;
    }
    return selectedWin;
}
function setCurWin(state, selectedWin, now, url, moduleId) {
    state.lastShowedPopUpWin = state.currentShowedPopUpWin;
    state.currentShowedPopUpWin = selectedWin;
    state.globalLastShowProps = state.globalCurShowProps;
    state.globalCurShowProps = { globalShowTime: now, globalShowURL: url, globalShowModuleId: moduleId };
}
export const PopupWinReducer = {
    registerNewWin: (state, action) => {
        const item = action.payload;
        const { id } = item;
        item.status = 'CLOSE';
        if (item.notShowPeriod === undefined) {
            item.notShowPeriod = 0;
        }
        if (item.type === 'WIN_FOR_NEW') {
            item.forNew = true;
        }
        item.registerTime = Date.now();
        const original = state.registeredPopUpWinMap[id];
        if (original && original.id) {
            item.lastSecondShowTime = original.lastSecondShowTime;
            item.lastShowTime = original.lastShowTime;
            item.lastCloseTime = original.lastCloseTime;
            item.setNoShow = original.setNoShow;
        }
        state.registeredPopUpWinMap[id] = item;
    },
    loadLocalDataAndMerge: (state, action) => {
        const localData = action.payload.data;
        Object.keys(localData).forEach(key => {
            const item = localData[key];
            const original = state.registeredPopUpWinMap[key];
            if (original && original.id) {
                original.lastShowTime = item.lastShowTime;
                original.lastSecondShowTime = item.lastSecondShowTime;
                original.lastCloseTime = item.lastCloseTime;
                original.setNoShow = item.setNoShow;
                original.status = 'CLOSE';
                state.registeredPopUpWinMap[key] = original;
            }
            else {
                item.status = 'CLOSE';
                item.registerTime = null;
                state.registeredPopUpWinMap[key] = item;
            }
        });
        state.localDataLoaded = true;
        state.showNewUserGuide = action.payload.isNewUser;
        state.versionInfo = action.payload.versionInfo;
        state.navigateVersion = action.payload.navigateVersion;
    },
    cancel(state, action) {
        if (state.currentShowedPopUpWin && state.currentShowedPopUpWin.status === 'OPEN') {
            const item = state.registeredPopUpWinMap[state.currentShowedPopUpWin.id];
            item.status = 'CLOSE';
            item.lastShowTime = item.lastSecondShowTime;
            item.lastSecondShowTime = null;
            item.canceled = true;
            state.currentShowedPopUpWin = state.lastShowedPopUpWin;
            state.lastShowedPopUpWin = null;
            state.globalCurShowProps = state.globalLastShowProps;
            state.globalLastShowProps = null;
        }
        else if (action.payload.winId) {
            const item = state.registeredPopUpWinMap[action.payload.winId];
            if (item && item.status === 'OPEN') {
                item.status = 'CLOSE';
                item.lastShowTime = item.lastSecondShowTime;
                item.lastSecondShowTime = null;
                item.canceled = true;
            }
        }
    },
    openPopWinInOrder(state, action) {
        state.popWinReady = state.popWinReady || !!action.payload.inited;
        if (!state.localDataLoaded) {
            return;
        }
        if (state.versionInfo === WAIMAO_PRODUCT_VERSIONS.FASTMAIL_EXPIRED || state.versionInfo === WAIMAO_PRODUCT_VERSIONS.FREE || state.navigateVersion) {
            return;
        }
        const url = window.location.href;
        const isFromNewbiePage = url.indexOf('from=noviceTask') > 0;
        if (isFromNewbiePage) {
            return;
        }
        const moduleItem = getSiteModule(url);
        const moduleId = moduleItem ? moduleItem.key : '_';
        const allWins = state.registeredPopUpWinMap;
        const now = Date.now();
        const cur = state.currentShowedPopUpWin;
        if (cur) {
            if (checkModuleMatched(cur, moduleId)) {
                return;
            }
            else {
                cur.lastCloseTime = now;
                cur.status = 'CLOSE';
                state.lastShowedPopUpWin = cur;
                state.currentShowedPopUpWin = null;
                const item = allWins[cur.id];
                if (item) {
                    item.status = 'CLOSE';
                    item.lastCloseTime = now;
                }
            }
        }
        const selectedWin = getSelectedWin(allWins, now, moduleId, state.showNewUserGuide, action.payload.winPrefix);
        if (selectedWin) {
            selectedWin.lastSecondShowTime = selectedWin.lastShowTime;
            selectedWin.lastShowTime = now;
            selectedWin.status = 'OPEN';
            selectedWin.canceled = false;
            setCurWin(state, selectedWin, now, url, moduleId);
        }
    },
    closeWinWithPrefix(state, action) {
        const { winPrefix, check } = action.payload;
        if (!winPrefix || winPrefix.length === 0) {
            return;
        }
        state.lastShowedPopUpWin = state.currentShowedPopUpWin || state.lastShowedPopUpWin;
        state.currentShowedPopUpWin = null;
        const allWins = state.registeredPopUpWinMap;
        const now = Date.now();
        Object.keys(allWins).forEach(key => {
            if (key && key.startsWith(winPrefix) && /^[0-9]+$/.test(key.substring(winPrefix.length))) {
                const item = allWins[key];
                item.status = 'CLOSE';
                item.setNoShow = check;
                item.lastCloseTime = now;
            }
        });
    },
    openOrCloseWin: (state, action) => {
        const { winId, status = 'CLOSE', check } = action.payload;
        const allWins = state.registeredPopUpWinMap;
        const item = allWins[winId];
        if (item) {
            const changed = item.status !== status;
            if (changed) {
                item.status = status;
                const now = Date.now();
                if (item.status === 'OPEN') {
                    if (state.currentShowedPopUpWin && state.currentShowedPopUpWin.status === 'OPEN') {
                        const openedWinId = state.currentShowedPopUpWin.id;
                        state.registeredPopUpWinMap[openedWinId].status = 'CLOSE';
                        state.registeredPopUpWinMap[openedWinId].lastCloseTime = now;
                    }
                    const siteModule = getSiteModule(window.location.href);
                    const moduleId = siteModule === null || siteModule === void 0 ? void 0 : siteModule.key;
                    setCurWin(state, item, now, window.location.href, moduleId);
                }
                else {
                    item.lastCloseTime = now;
                    item.setNoShow = check;
                    state.lastShowedPopUpWin = state.currentShowedPopUpWin || state.lastShowedPopUpWin;
                    state.currentShowedPopUpWin = null;
                }
            }
        }
    },
};
